import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  font-weight: 600;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { fixedHeightKeys, fixedHeightMixin, fontSpacingKeys, fontSpacingMixin } from '../mixins/typography';
import { withOmitProps } from '../helpers/elements';
import { PriceMedium as PriceMediumSize } from './constants/price-medium.size';
import { PriceMedium as PriceMediumSpacing } from './constants/price-medium.spacing';
import { baseTypographyStyle } from './style/base';
import { baseTypographyKeys, baseTypographyMixin } from './mixins/base';
import { lineHeight } from '../style/line-height';
import { fontSize } from '../style/font-size';
var PriceMedium = styled.p.withConfig(withOmitProps([].concat(fontSpacingKeys, fixedHeightKeys, baseTypographyKeys)))(_templateObject(), baseTypographyStyle, baseTypographyMixin, fontSpacingMixin(PriceMediumSpacing), fontSize(PriceMediumSize.fontSize), lineHeight(PriceMediumSize.lineHeight), fixedHeightMixin(PriceMediumSize.lineHeight)); // @ts-expect-error Assigning type to never

PriceMedium._size = PriceMediumSize;
export default PriceMedium;